import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AdminCategoryModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminCategoryModule;